import i18n from './i18n'
import type { ErrorCode, ErrorData, Locales } from '@captaincause/types'

export function getErrorLabel(
  errorCode: ErrorCode | undefined,
  locale: Locales,
  fallbackErrorMessage?: string,
) {
  const t = i18n[locale] ?? i18n.fr
  if (!errorCode) {
    return fallbackErrorMessage ?? t['errors.generic']
  }

  return t[`errors.${errorCode}`] ?? t['errors.generic']
}

export interface ThrowableApiErrorData {
  message: string
  status: number
  data: ErrorData
}

export function ThrowableApiError({
  message,
  status,
  data,
}: ThrowableApiErrorData): ThrowableApiErrorData {
  return {
    message,
    status,
    data,
  }
}

export interface ThrowableServerApiErrorData {
  message: string
  status?: number
  data: any
}

export function ThrowableServerApiError({
  message,
  status,
  data,
}: ThrowableServerApiErrorData): ThrowableServerApiErrorData {
  return {
    message,
    status,
    data,
  }
}
